<template>
  <EditorWrapper>
    <div class="p-8 pb-24">
      <LoadingSpinner v-if="domainStore.loadingDomain" />
      <div
        v-else-if="
          vendorKey === 'all' && domainStore.domain.agent.alias !== 'zzzz'
        "
        class="text-center"
      >
        <h2 class="text-5xl font-semibold text-gray-700">
          {{ domainStore.domain.name }}
        </h2>
        <h2 class="mt-8 text-2xl font-semibold">No vendor selected</h2>
        <p class="mt-2">Please select a vendor in order to view this page.</p>
      </div>
      <div
        v-else-if="
          vendorKey &&
          vendorKey !== 'all' &&
          !domainStore.domain.vendor_approved
        "
      >
        <h2 class="text-5xl font-semibold text-gray-700">
          {{ domainStore.domain.name }}
        </h2>

        <p class="font-medium text-gray-700 mt-3">
          Although {{ domainStore.domain.name }} is in the participation list,
          you have not been granted permission to suggest content.
        </p>
      </div>
      <div v-else id="domain-overview" class="container max-w-6xl mx-auto">
        <div id="domain-info-section">
          <article>
            <div class="pb-4" v-if="domainStore.domain">
              <h2 class="text-5xl font-semibold text-gray-700">
                {{ domainStore.domain.name }}
              </h2>
              <p class="font-medium text-gray-700 mt-3">
                Welcome to the CMP editor! Make a suggestion for the contents of
                <a
                  class="place-self-center"
                  :href="`https://${domainStore.domain.name}`"
                  target="_blank"
                >
                  {{ domainStore.domain.name }}
                </a>
                by selecting from options in the left
                <ArrowLeft class="pointer-events-none w-5 h-5 inline" />
                navigation.
              </p>
              <div class="w-full my-4 grid grid-cols-1 md:grid-cols-3 gap-4">
                <StatBlock
                  v-if="domainStore.domain?.product_type"
                  label="product type"
                  :stat="domainStore.domain?.product_type"
                  :loading="domainStore.loadingDomain"
                  dense
                />
                <StatBlock
                  label="Last Update"
                  :stat="
                    domainStore.domain?.last_cmp_dco_date
                      ? formatRelative(
                          parseISO(domainStore.domain?.last_cmp_dco_date),
                          new Date(),
                        )
                      : 'N/A'
                  "
                  :loading="domainStore.loadingDomain"
                  dense
                />
                <StatBlock
                  label="Last suggestion"
                  :stat="
                    domainStore.domain?.last_cmp_suggestion_date
                      ? formatRelative(
                          parseISO(
                            domainStore.domain?.last_cmp_suggestion_date,
                          ),
                          new Date(),
                        )
                      : 'N/A'
                  "
                  :loading="domainStore.loadingDomain"
                  dense
                />
              </div>
              <h2 class="text-2xl font-semibold text-gray-700">
                Agent Information
              </h2>
              <AgentInformation :agent="domainStore.domain.agent" />
            </div>
          </article>
        </div>
        <StatSection
          v-if="domainStore.domain"
          id="domain-stats"
          :domain="domainStore.domain.name"
        />
      </div>
    </div>
  </EditorWrapper>
  <Onboarding page="domain" />
</template>

<script setup>
import { formatRelative, parseISO } from "date-fns";
import { storeToRefs } from "pinia";
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import AgentInformation from "@/components/AgentInformation.vue";
import EditorWrapper from "@/components/editor/EditorWrapper.vue";
import ArrowLeft from "@/components/icons/ArrowLeft.vue";
import CircleUser from "@/components/icons/CircleUser.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Onboarding from "@/components/Onboarding.vue";
import RecentActivity from "@/components/RecentActivity.vue";
import StatBlock from "@/components/StatBlock.vue";
import StatSection from "@/components/StatSection.vue";
import useDomainStore from "@/stores/domain";
import useUserStore from "@/stores/user";

const route = useRoute();
const domainStore = useDomainStore();

const userStore = useUserStore();
const { vendor, vendorKey } = storeToRefs(userStore);

onMounted(async () => {
  await domainStore.ensureDomain(route.params.domain);
});
</script>
